import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';
import styles from './styles.module.css';

export default function Navbar() {
  const { t, i18n } = useTranslation('landing');

  const navItems = [
    { to: 'prob', label: t('nav.prob') },
    { to: 'how', label: t('nav.how') },
    { to: 'cases', label: t('nav.cases') },
    { to: 'impl', label: t('nav.impl') },
    { to: 'faq', label: t('nav.faq') },
  ];

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('vox-lang', lang);
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.logo}>
        <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
          <rect width="40" height="40" rx="8" fill="#132d52" />
          <rect x="17" y="8" width="3" height="24" rx="1.5" fill="white" />
          <rect x="22" y="13" width="3" height="14" rx="1.5" fill="#5BA4CF" />
          <rect x="12" y="15" width="3" height="10" rx="1.5" fill="white" opacity=".7" />
        </svg>
        <span className={styles.brand}>
          Vox<span>Reports</span>
        </span>
      </div>
      <div className={styles.links}>
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            smooth
            duration={500}
            offset={-64}
            className={styles.link}
          >
            {item.label}
          </Link>
        ))}
        <div className={styles.langSwitch}>
          <button
            className={i18n.language === 'es' ? styles.langActive : undefined}
            onClick={() => changeLang('es')}
          >
            ES
          </button>
          <span>|</span>
          <button
            className={i18n.language === 'en' ? styles.langActive : undefined}
            onClick={() => changeLang('en')}
          >
            EN
          </button>
        </div>
        <a
          href="https://app.voxreports.com/login"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.login}
        >
          {t('nav.login')}
        </a>
        <Link
          to="cta"
          smooth
          duration={500}
          offset={-64}
          className={styles.cta}
        >
          {t('nav.cta')}
        </Link>
      </div>
    </nav>
  );
}
